import React,{useEffect} from "react";
import { Container, Button } from "react-bootstrap";


import { useNavigate } from 'react-router-dom';
import Succes_lottie from "./../../../../../animation/succes_lottie/Succes_lottie"
import CommonBreadcrumb from './../../../../../common_components/breadcrumb/CommonBreadcrumb';
import WhiteButton from './../../../../../common_components/common_button/WhiteButton';
import Login_Succes_Lottie from './../../../../../animation/login_succes_lottie/Login_Succes_Lottie';

const BankDetailsUpdated= () => {
    const navigate =useNavigate()
  const breadcrumbItems = [
   { label: "Profile", link: "/profile" },
    { label: "Wallet & Earnings" ,link:"/wallet&earnings"},
    { label: "Update Bank Details"  },
  ];

   useEffect(() => {
      const timer = setTimeout(() => {
        navigate("/withdraw");
      }, 3000);
  
      return () => clearTimeout(timer);
    }, [navigate]);

  return (
    <section className="kyc-verified-section Bank-Details-Updated-section">
      <CommonBreadcrumb items={breadcrumbItems} />
      <Container className="kyc-wrapper text-center">
        {/* Card */}
        <div className="kyc-card ">
          <Login_Succes_Lottie />
          <div className="text-area">
            <h4 className="kyc-title">Bank Details Updated!</h4>
            <p className="kyc-text">
             Your bank details have been submitted and are under verification. You can now use them for withdrawals.
            </p>
          </div>
        </div>

        {/* Button */}
        <WhiteButton
          title={"Back to Withdraw Earnings"}
          bg="#000"
          color="#f35f37"
          hoverColor="#f35f37"
          hoverBg={"#000"}
          
          onClick={() => navigate("/withdraw")}
        />
      </Container>
    </section>
  );
};

export default BankDetailsUpdated;
